// src/pages/PasswordRecovery.jsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/Logo_DMARCOne.png";
import { recover_password } from "../services/auth";

function PasswordRecoveryPage() {
  const navigate = useNavigate();

  const [correo, setCorreo] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [mensaje, setMensaje] = useState("");
  const [listoParaVerificar, setListoParaVerificar] = useState(false);
  const [codigoDebug, setCodigoDebug] = useState(null); // opcional para modo debug

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMensaje("");
    setCodigoDebug(null);
    setListoParaVerificar(false);
    setLoading(true);

    try {
      const resp = await recover_password(correo);
      // resp: { detail }

      // Guardamos el correo para el segundo paso (verify-code)
      localStorage.setItem("correo_validacion_pendiente", correo);

      // Mensaje principal
      let msg =
        resp.detail ||
        "Te hemos enviado un código de verificación a tu correo. Ingresa el código en la siguiente pantalla.";

      // Si estamos en modo debug y viene el código, lo mostramos adicionalmente
      if (resp.modo_debug && resp.codigo) {
        msg += ` (Modo debug: código ${resp.codigo})`;
        setCodigoDebug(resp.codigo);
      }

      setMensaje(msg);
      setListoParaVerificar(true);
    } catch (err) {
      console.error("[PasswordRecoveryPage] Error", err);
      setError(err.message || "Error al recuperar contraseña.");
    } finally {
      setLoading(false);
    }
  };

  const irAChangePassword = () => {
    navigate("/change-password");
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: "#414142" }} // gris oscuro corporativo
    >
      <div
        className="w-full max-w-md rounded-2xl shadow-xl p-8"
        style={{
          backgroundColor: "#FFFFFF", // blanco
          border: "1px solid #E5E7EB",
        }}
      >
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src={logo}
            alt="DMARCONE"
            className="w-72 h-auto" // usa bien el 1000x222
          />
        </div>

        <h1
          className="text-xl font-semibold text-center mb-1"
          style={{ color: "#414142" }} // gris oscuro
        >
          Recuperar contraseña
        </h1>
        <p
          className="text-sm text-center mb-6"
          style={{ color: "#6B7280" }} // gris medio
        >
          Ingresa con tu correo corporativo.
        </p>

        {/* Mensaje de éxito (verde) */}
        {mensaje && (
          <div className="mb-4 rounded-md bg-emerald-50 border border-emerald-200 px-3 py-2 text-sm text-emerald-700">
            {mensaje}
            {codigoDebug && (
              <div className="mt-1 text-xs opacity-80">
                Código (debug): <strong>{codigoDebug}</strong>
              </div>
            )}
          </div>
        )}

        {/* Error (rojo) */}
        {error && (
          <div className="mb-4 rounded-md bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              className="block text-sm font-medium mb-1"
              style={{ color: "#414142" }}
            >
              Correo electrónico
            </label>
            <input
              type="email"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              required
              className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#00C4CC] focus:border-[#00C4CC]"
              style={{
                borderColor: "#D1D5DB",
                color: "#414142",
              }}
              placeholder="tucorreo@dominio.cl"
            />
          </div>

          <p className="text-[11px] mt-1" style={{ color: "#9CA3AF" }}>
            Por seguridad, te enviaremos un código de verificación a tu correo.
          </p>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg text-white text-sm font-medium py-2.5 mt-2 disabled:opacity-50 disabled:cursor-not-allowed transition bg-[#00C4CC] hover:bg-[#00AEB5]"
          >
            {loading ? "Validando..." : "Ingresar"}
          </button>
        </form>

        {/* Botón secundario para ir al 2FA, solo cuando ya pasó el login */}
        {listoParaVerificar && (
          <button
            onClick={irAChangePassword}
            className="w-full mt-4 rounded-lg text-sm font-medium py-2.5 border transition hover:bg-[#E0FBFC]"
            style={{
              borderColor: "#00C4CC",
              color: "#00C4CC",
            }}
          >
            Continuar a verificación de código
          </button>
        )}
      </div>
    </div>
  );
}

export default PasswordRecoveryPage;
